<button
	(click)="openDialog()"
	*ngIf="!isMenuButton"
	[ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"
	color="primary"
	mat-raised-button
>
	{{ label }}
</button>

<button (click)="openDialog()" *ngIf="isMenuButton" class="{{ labelClass }}" mat-menu-item>
	{{ label }}
</button>
